import styled from 'styled-components';

export default styled.section`
	display: flex;
	flex-direction: column;
	height: 100%;
	.header {
		width: 100%;
		background-color: ${(props) => props.theme.color[`grey100`]};
		border-bottom: solid 1px ${(props) => props.theme.color[`grey300`]};
		padding: 0.5rem 1rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		h3 {
			font-size: 1.3rem;
			margin: 0;
			display: flex;
			align-items: center;
			line-height: normal;
			font-weight: bold;
			max-width: 82%;
			.header-text {
				display: inline-block;
				width: 100%;
				margin-right: 1rem;
				color: ${(props) => props.theme.color[`black`]};
			}
		}
		.badge-count {
			background-color: ${(props) => props.theme.color[`grey500`]};
			color: ${(props) => props.theme.color[`white`]};
			font-size: 1rem;
			padding: 0.2rem 0.5rem;
			border-radius: 50%;
		}
		.motif-icon,
		svg {
			width: 2rem !important;
			height: 2rem !important;
		}
	}
	.links {
		margin: 2rem 0;
		display: flex;
		justify-content: space-between;
		button {
			font-size: 1.6rem;
		}
		button:disabled {
			cursor: default;
		}
		& > div:disabled {
			cursor: default;
		}
	}
	.loader-container {
		position: relative;
		padding: 10%;
	}
	.empty-list-message {
		display: flex;
		justify-content: center;
		font-size: 1.6rem;
		padding: 10%;
		margin: 1rem 0;
		border: 1px solid ${(props) => props.theme.color[`grey300`]};
		button {
			font-size: 1.6rem;
			padding: 0 0.6rem;
		}
	}
	.loader-container .motif-progress-loader-container {
		background: transparent;
	}

	.tab-text {
		width: calc(100% - 2rem);
	}

	.ellipsis {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;
